import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import GovernmentNumbersBody from './GovernmentNumbersBody';
import GovernmentNumbersData from './GovernmentNumbersData';

const Edit = (props) => {
  const { data, block, selected, intl } = props;

  return (
    <>
      <GovernmentNumbersBody data={data} id={block} intl={intl} isEditMode />
      <SidebarPortal selected={selected}>
        <GovernmentNumbersData
          key={block}
          {...props}
          data={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
